import styled from 'styled-components';

type ContainerProps = {
    isOpen?: boolean;
};

export const Container = styled.div``;

export const ToolTipContainer = styled.div`
    display: table-row;
    margin-right: 12px;
    position: absolute;
    opacity: ${(props: ContainerProps) => (props.isOpen ? 1 : 0)};
    // transition: opacity 200ms linear; // TODO: Fix issues with blur
    visibility: ${(props: ContainerProps) => (props.isOpen ? 'visible' : 'hidden')};
    z-index: 15;
`;

export const ToolTipCanvas = styled.div`
    border-radius: 25px;
    display: table-cell;
    padding: 25px 30px;
    width: 347px;
    background: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(80px);
`;

export const Title = styled.div`
    margin-bottom: 10px;
`;

export const TipContainer = styled.div`
    display: table-cell;
    vertical-align: middle;
`;

export const TipRight = styled.div`
    border-color: transparent transparent transparent rgba(116, 118, 138, 0.8); // TODO: This color should be a blur
    border-style: solid;
    border-width: 11.5px 0 11.5px 10px;
    height: 0;
    line-height: 0;
    width: 0;

    // Fixes for IE
    _border-color: #000000 #000000 #000000 rgba(116, 118, 138, 0.8);
    _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');
`;
